import { Scene, OrthographicCamera, WebGLRenderer, PointLight, AmbientLight, Vector3, Group, ObjectLoader, BoxGeometry, MeshBasicMaterial, Mesh } from 'three'
import { Math as THREEMath } from 'three'
import GLTFLoader from 'three-gltf-loader'

const t3d = {}

t3d.setup = function(canvas, width, height) {
  t3d.stage       = canvas
  t3d.scene       = new Scene()
  t3d.width = width
  t3d.height = height

  t3d.camera      = new OrthographicCamera(
  t3d.stage.width  / -2, t3d.stage.width  / 2,
  t3d.stage.height /  2, t3d.stage.height / -2,  50, 10000 )

  t3d.renderer    = new WebGLRenderer({
    alpha: true,
    canvas: t3d.stage,
    antialias: true,
    preserveDrawingBuffer: true
  })

  t3d.containers   = {
    eye_left: new Group(),
    eye_right: new Group(),
    nose: new Group(),
    eyebrow_left: new Group(),
    eyebrow_middle: new Group(),
    eyebrow_right: new Group(),
  }
  t3d.containers_position = {
    eye_left: 39,
    eye_right: 42,
    nose: 30,
    eyebrow_left: 19,
    eyebrow_middle: 27,
    eyebrow_right: 24,
  }

  t3d.modelZ      = 2000

  t3d.renderWidth   = 0
  t3d.renderHeight  = 0

  t3d.face = null

  t3d.renderer.setClearColor(0x000000, 0)
  t3d.renderer.setPixelRatio(window.devicePixelRatio)
  t3d.renderer.gammaFactor = 2.2
  t3d.renderer.gammaOutput = true

  t3d.scene.add(new AmbientLight(0xffffff, 1))
  t3d.scene.add(new PointLight(0xffffff, 1))

  _.each(t3d.containers, (object, name) => {
    // object.add(t3d.createBox())
    t3d.scene.add(object)
  })

  t3d.loadFace()
  t3d.updateLayout()
}

t3d.loadFace = () => {
  const loader = new GLTFLoader()
  loader.load(
    require('./face.glb'),
    gltf => {
      var mesh = null
      gltf.scene.traverse(child => {
        if(child.material)
          mesh = child
      })
      t3d.face = mesh
      const mat = new MeshBasicMaterial( { color: 0x000000 } )
      mesh.material = mat
      mesh.material.opacity = 0
      mesh.material.transparency = true
      // mesh.material.depthWrite = false
      TweenMax.set(mesh, { three: { scale: .5, rotationX: -90, rotationZ: -180 } })
      t3d.containers.nose.add(mesh)
    }
  )
}

t3d.updateLayout = function() {
  const width = t3d.width
  const height = t3d.height

  t3d.renderWidth   = width
  t3d.renderHeight  = height

  t3d.renderer.setSize(width, height, true)

  t3d.camera.left   = width  / -2
  t3d.camera.right  = width  /  2
  t3d.camera.top    = height /  2
  t3d.camera.bottom = height / -2

  t3d.camera.position.set(0, 0, 0)
  t3d.camera.lookAt(new Vector3(0, 0, 1))
  t3d.camera.updateProjectionMatrix()
}

t3d.createBox = () => {
  const mesh = new Mesh(new BoxGeometry( 1, 1, 1 ), new MeshBasicMaterial({ color: 0x00ff00 }))
  mesh.scale.set(.1, .1, .1)
  return mesh
}

t3d.update = function(face) {
  _.each(t3d.containers, (object, name) => {
    var rx  = THREEMath.radToDeg(-face.rotationX)
    var ry  = THREEMath.radToDeg(-face.rotationY)
    var rz  = THREEMath.radToDeg( face.rotationZ)
    var s   =  face.scale
    var x   = -(face.points[t3d.containers_position[name]].x - (t3d.renderWidth  * 0.5))
    var y   = -(face.points[t3d.containers_position[name]].y - (t3d.renderHeight * 0.5))
      - ((Math.abs(ry) / 45.0) * -2.0)
      + ((rx < 0) ? (rx * 0.20) : 0.0)
    var z   =  t3d.modelZ

    rx      = rx -  4 * (Math.abs(ry) / 45.0)
    rz      = rz - ry * 0.066 * (Math.abs(rx) / 20.0)
    ry      *= 0.9

    TweenLite.to(object, .1, { three: {
      x: x,
      y: y,
      z: z,
      scale: s,
      rotationX: rx,
      rotationY: ry,
      rotationZ: rz
    }})
    // object.position.set(x, y, z)
    // object.scale.set(s, s, s)
    // object.rotation.set(THREEMath.degToRad(rx), THREEMath.degToRad(ry), THREEMath.degToRad(rz))
  })
  t3d.renderer.render(t3d.scene, t3d.camera)
}

t3d.render = function() {
  t3d.renderer.render(t3d.scene, t3d.camera)
}

export default t3d
